import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Navigation() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const isCurrentPage = (path: string) => {
    return location.pathname === path;
  };

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-right z-50 w-full bg-white/90 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 md:py-4">
        <div className="flex items-center justify-between">
          {/* Desktop Left Links */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/" 
              onClick={handleLinkClick}
              className={`text-xl text-gray-800 hover:text-emerald-500 transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                isCurrentPage('/') ? 'font-bold' : 'font-normal'
              }`}
            >
              홈
            </Link>
            <Link 
              to="/products" 
              onClick={handleLinkClick}
              className={`text-lg text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                isCurrentPage('/products') ? 'font-bold text-gray-800' : 'font-normal'
              }`}
            >
              제품
            </Link>
            <Link 
              to="/catalog" 
              onClick={handleLinkClick}
              className={`text-lg text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                isCurrentPage('/catalog') ? 'font-bold text-gray-800' : 'font-normal'
              }`}
            >
              카달로그
            </Link>
            <Link 
              to="/gallery" 
              onClick={handleLinkClick}
              className={`text-lg text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                isCurrentPage('/gallery') ? 'font-bold text-gray-800' : 'font-normal'
              }`}
            >
              현장사진 갤러리
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-emerald-500 transition-colors cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
          
          {/* Center Logo */}
          <div className="lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2">
            <div className="bg-emerald-500 px-4 md:px-6 py-1.5 md:py-2 rounded-full">
              <Link to="/" onClick={handleLinkClick} className="cursor-pointer">
                <span className="text-white font-bold text-sm md:text-lg" style={{ fontFamily: 'NexonMaplestory, sans-serif' }}>
                  (주)그린디자인테크
                </span>
              </Link>
            </div>
          </div>
          
          {/* Desktop Right Links */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/about" 
              onClick={handleLinkClick}
              className={`text-lg text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                isCurrentPage('/about') ? 'font-bold text-gray-800' : 'font-normal'
              }`}
            >
              회사소개
            </Link>
            <Link 
              to="/contact" 
              onClick={handleLinkClick}
              className={`text-lg text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                isCurrentPage('/contact') ? 'font-bold text-gray-800' : 'font-normal'
              }`}
            >
              견적 문의
            </Link>
          </div>

          {/* Mobile Contact Button */}
          <Link 
            to="/contact" 
            onClick={handleLinkClick}
            className="lg:hidden text-sm text-emerald-600 font-semibold hover:text-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            문의
          </Link>
        </div>

        {/* Mobile Menu Drawer */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/" 
                onClick={handleLinkClick}
                className={`text-base text-gray-800 hover:text-emerald-500 transition-colors duration-300 cursor-pointer py-2 ${
                  isCurrentPage('/') ? 'font-bold text-emerald-600' : 'font-normal'
                }`}
              >
                홈
              </Link>
              <Link 
                to="/products" 
                onClick={handleLinkClick}
                className={`text-base text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer py-2 ${
                  isCurrentPage('/products') ? 'font-bold text-emerald-600' : 'font-normal'
                }`}
              >
                제품
              </Link>
              <Link 
                to="/catalog" 
                onClick={handleLinkClick}
                className={`text-base text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer py-2 ${
                  isCurrentPage('/catalog') ? 'font-bold text-emerald-600' : 'font-normal'
                }`}
              >
                카달로그
              </Link>
              <Link 
                to="/gallery" 
                onClick={handleLinkClick}
                className={`text-base text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer py-2 ${
                  isCurrentPage('/gallery') ? 'font-bold text-emerald-600' : 'font-normal'
                }`}
              >
                현장사진 갤러리
              </Link>
              <Link 
                to="/about" 
                onClick={handleLinkClick}
                className={`text-base text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer py-2 ${
                  isCurrentPage('/about') ? 'font-bold text-emerald-600' : 'font-normal'
                }`}
              >
                회사소개
              </Link>
              <Link 
                to="/contact" 
                onClick={handleLinkClick}
                className={`text-base text-gray-700 hover:text-emerald-500 transition-colors duration-300 cursor-pointer py-2 ${
                  isCurrentPage('/contact') ? 'font-bold text-emerald-600' : 'font-normal'
                }`}
              >
                견적 문의
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
